import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';


export class Slider {
    constructor(breakpointLargeMedium, breakpointMedium) {
        this.speed = 3000;
        this.fadetime = 800;
        this.shuffle = null;
        this.breakpointLargeMedium = breakpointLargeMedium;
        this.breakpointMedium = breakpointMedium;
        this.isstarted = false;
    }

    init() {
        this.startSlider();
        window.addEventListener('resize', this.startSlider.bind(this));
    }
    startSlider() {
        const self = this;

        const buildSlider = (element, id) => {
            if (element.getAttribute('data-auto') == 1) {
                return new Swiper(element, {
                    modules: [Autoplay, EffectFade],
                    slidesPerView: 1,
                    loop: true,
                    speed: 800,
                    grabCursor: true,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 2000,
                        //disableOnInteraction: true
                    },
                });
            } else {
                return new Swiper(element, {
                    modules: [Autoplay, EffectFade],
                    speed: 800,
                    grabCursor: true,
                    slidesPerView: 1,
                    breakpoints: {
                        768: {
                          slidesPerView: 2,
                          //spaceBetween: 50,
                        },
                      },
                    on: {
                        slideChange: function () {
                            element.parentNode.querySelector('.count-curr').textContent = this.activeIndex + 1;
                        },
                    },
                });
            }
        }

        if (document.querySelectorAll('.image-columns').length > 0) {
            Array.from(document.querySelectorAll('.image-columns')).forEach(function (col) {
                if(window.innerWidth > self.breakpointMedium) {
                    col.querySelector('.count-total').textContent = 2;
                } else {
                    col.querySelector('.count-total').textContent = 3;
                }
            });
        }

        if (window.innerWidth <= this.breakpointLargeMedium) {
            if (!this.isstarted) {
                this.isstarted = true;

                if (document.querySelectorAll('.headerimage').length > 0) {
                    Array.from(document.querySelectorAll('.headerimage .swiper-container figure')).forEach(function (img) {
                        img.classList.add('swiper-slide');
                        img.classList.add('swiper-lazy');
                    });
                }
                if (document.querySelectorAll('.image-columns').length > 0) {
                    Array.from(document.querySelectorAll('.image-columns')).forEach(function (col) {
                        //col.className = '';
                        
                        col.querySelector('.wp-block-columns').classList.add('swiper-wrapper');
                    });
                    Array.from(document.querySelectorAll('.image-columns .swiper-container .wp-block-column')).forEach(function (img) {
                        //img.className = '';
                        img.classList.add('swiper-slide');
                        img.classList.add('swiper-lazy');
                        
                        //
                    });
                }

                Array.from(document.querySelectorAll('.swiper-container')).forEach((item, id) => {
                    const slider = buildSlider(item, id);
                });
            }
        } else {
            if (this.isstarted) {
                Array.from(document.querySelectorAll('.swiper-container')).forEach(function (item) {
                    if (item.swiper) {
                        item.swiper.destroy(true, true);
                    }
                });
            }
            this.isstarted = false;
        }
    }
}